import React, { useState, useEffect } from "react";
import {
  DEFAULT_ADULTS_ROOM_SEARCH,
  DEFAULT_CHECKIN_DATE,
  DEFAULT_CHECKOUT_DATE,
  DEFAULT_CHILDREN_ROOM_SEARCH,
  DEFAULT_ROOMS_ROOM_SEARCH,
} from "./entities/lodge/lodgeConstants";
import { RESTAURANT_CONSTANTS } from "./entities/restaurant/restaurantConstants";
import { EXPERIENCES } from "./entities/experience/experiencesConstants";
import { getLoggedInUser, loginWithFacebookToken } from "./library/user";
import { useFacebook } from "./container/User/facebook";
import Papa from "papaparse";
import { RENTACAR_CONSTANTS } from "./entities/rentacar/rentacarConstants";
import { INITIAL_PAGINATION_PAGE_SIZE } from "./config/layoutConfig";

export const AppContext = React.createContext({});

const translation = require("./files/ahp-translation.csv");

const InfoContext = ({ children }) => {
  const [language, setLanguage] = useState("pt");

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  const t = (key) => {
    const row = translation.find((csvRow) => csvRow[0] === key);

    if (!row || row.length === 0) return "";

    let index;
    switch (language) {
      case "pt":
        index = 1;
        break;
      case "en":
        index = 2;
        break;
      case "es":
        index = 3;
        break;
      case "fr":
        index = 4;
        break;
      case "de":
        index = 5;
        break;
      default:
        break;
    }

    let text = "";
    // portuguese text exists
    // default to portuguese
    if (row[1]) text = row[1];
    if (index !== 1 && row[index]) text = row[index];
    const str = capitalizeFirstLetter(text);
    return str;
  };

  // context data
  const [user, setUser] = useState(false);
  const [commonFilter, setCommonFilter] = useState({
    villages: [],
    name: "",
  });
  const [lodge, setLodge] = useState({
    adults: DEFAULT_ADULTS_ROOM_SEARCH,
    children: DEFAULT_CHILDREN_ROOM_SEARCH,
    rooms: DEFAULT_ROOMS_ROOM_SEARCH,
    checkIn: DEFAULT_CHECKIN_DATE,
    checkOut: DEFAULT_CHECKOUT_DATE,
  });
  const [restaurant, setRestaurant] = useState({
    people: RESTAURANT_CONSTANTS.DEFAULT_PEOPLE,
    date: RESTAURANT_CONSTANTS.DEFAULT_DATE,
    service: RESTAURANT_CONSTANTS.DEFAULT_SERVICE,
    time: RESTAURANT_CONSTANTS.DEFAULT_TIME,
  });
  const [event, setEvent] = useState({
    category: undefined,
    date: undefined,
    tickets: 1,
  });
  const [experience, setExperience] = useState({
    people: 1,
    category: null,
    date: EXPERIENCES.DEFAULT_DATE,
  });
  const [monument, setMonument] = useState({});
  const [rentacar, setRentacar] = useState({
    extras: [],
    typology: RENTACAR_CONSTANTS.DEFAULT_TYPE,
  });
  const [rentabike, setRentabike] = useState({});
  const [transportation, setTransportation] = useState({
    from: undefined,
    to: undefined,
    date: undefined,
    time: undefined,
    type: undefined,
    amenities: [],
  });
  const [guide, setGuide] = useState({
    date: null,
    time: null,
    language: null,
    type: null,
    specialization: null,
  });
  const [goods, setGoods] = useState({
    category: null,
    minPrice: 0,
    maxPrice: 100,
  });
  const [villages, setVillages] = useState([]);
  const [name, setName] = useState("");
  const [type, setType] = useState(undefined);
  const [immediateConfirmation, setImmediateConfirmation] = useState(false);
  const [reservations, setReservations] = useState([]);
  const [client, setClient] = useState({ id: "123" });
  const [pageSize, setPageSize] = useState(INITIAL_PAGINATION_PAGE_SIZE);
  const [languageLocation, setLanguageLocation] = useState("pt-pt");
  // the updateComponent state is used to update a component when the same route is used (with different parameters)
  // a simple history.push to the same route won't work
  const [updateComponent, setUpdateComponent] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const setService = (type, prevState, field, value) => {
    if (type === "lodge") setLodge({ ...prevState, [field]: value });
    if (type === "restaurant") setRestaurant({ ...prevState, [field]: value });
    if (type === "experience") setExperience({ ...prevState, [field]: value });
    if (type === "rentacar") setRentacar({ ...prevState, [field]: value });
    if (type === "transportation")
      setTransportation({ ...prevState, [field]: value });
    if (type === "guide") setGuide({ ...prevState, [field]: value });
    if (type === "goods") setGoods({ ...prevState, [field]: value });
    if (type === "event") setEvent({ ...prevState, [field]: value });
  };

  //
  const [FB, isReady] = useFacebook();

  const [resetPasswordId, setResetPasswordId] = useState(null);

  const value = {
    user,
    setUser,
    lodge,
    setLodge,
    restaurant,
    setRestaurant,
    event,
    setEvent,
    experience,
    setExperience,
    rentacar,
    setRentacar,
    rentabike,
    setRentabike,
    transportation,
    setTransportation,
    guide,
    setGuide,
    goods,
    setGoods,
    monument,
    setMonument,
    setService,
    // reservations,
    // setReservations,
    client,
    setClient,
    language,
    setLanguage,
    languageLocation,
    updateComponent,
    setUpdateComponent,
    immediateConfirmation,
    setImmediateConfirmation,
    commonFilter,
    setCommonFilter,
    villages,
    setVillages,
    name,
    setName,
    type,
    setType,
    t,
    pageSize,
    setPageSize,
    refresh,
    setRefresh,
    resetPasswordId,
    setResetPasswordId,
  };

  // // verify if user is logged-in
  useEffect(() => {
    // // check if is loggedin with Facebook
    // if (FB.getLoginStatus)
    //   FB.getLoginStatus(function (response) {
    //     console.log("response", response);
    //     loginWithFacebookToken(response.accessToken);
    //   });

    const token = window.localStorage.getItem("openkit");
    const getLoggedInUserFn = async () => {
      const user = await getLoggedInUser();
      setUser(user);
    };
    if (token) getLoggedInUserFn();
  }, []);

  return (
    <>
      <AppContext.Provider value={value}>{children}</AppContext.Provider>
    </>
  );
};

export default InfoContext;
